import React from 'react';
import * as R from 'ramda';
import { FeatureFlag } from 'react-launch-darkly';

const AdditionalNotesV1 = ({notes}) => {
    const additionalNotes = notes ? (
        <textarea disabled className="additional-notes-area" cols="30" rows="16">
            {notes}
        </textarea>
    ) : null;

    return (
        <div>
            <div id="additional-notes-title" className="section-title">
                Additional Notes
            </div>
            {additionalNotes}
        </div>
    );
};

// AdditionalNotesV2 component New version of the RTL page
const AdditionalNotesV2 = ({notes}) => {
    let additionalNotes = null;
    if (notes) {
        const lines = notes.split('\n');
        const mid = Math.ceil(lines.length / 2);
        const left = lines.slice(0, mid);
        const right = lines.slice(mid);

        additionalNotes = (
            <div className="section-row">
                <textarea
                    disabled
                    className="additional-notes-area"
                    cols="30"
                    rows="16"
                    value={left.join('\n')}
                />
                <textarea
                    disabled
                    className="additional-notes-area"
                    cols="30"
                    rows="16"
                    value={right.join('\n')}
                />
            </div>
        );
    }

    return (
        <div>
            {additionalNotes}
        </div>
    );
};


const AdditionalNotes = (props) => (
    <FeatureFlag
        flagKey="order-form-v2-enabled"
        renderFeatureCallback={flag =>
            flag
                ? <AdditionalNotesV2 {...props} />
                : <AdditionalNotesV1 {...props} />
        }
        renderDefaultCallback={() => <AdditionalNotesV1 {...props} />}
    />
);

export default AdditionalNotes;


// WEBPACK FOOTER //
// ./components/verify_receipt_common/additional_notes.js